/** Development diagnostics are omitted from production logging. Never pass credentials. */
export function debugLog(...values: unknown[]): void {
  if (import.meta.env.DEV) {
    // eslint-disable-next-line no-console -- This is the single development logging boundary.
    console.debug(...values);
  }
}
